import { render } from "./IndicadoresProjetos.vue?vue&type=template&id=216c176f&scoped=true"
import script from "./IndicadoresProjetos.vue?vue&type=script&lang=js"
export * from "./IndicadoresProjetos.vue?vue&type=script&lang=js"

import "./IndicadoresProjetos.vue?vue&type=style&index=0&id=216c176f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216c176f"]])

export default __exports__